import React, { useState, useRef } from 'react';
import { LiveAudioVisualizer, AudioVisualizer } from 'react-audio-visualize';
import WaveSurfer from 'wavesurfer.js'

var wavesurfer = false;



export function EmptyWaveform()
{
  return (<div height={100}></div>)
}



export function MediaRecorderWaveform (recorder, padding)
{
  //recorder : a MediaRecorder object.
  //padding : padding size (in px) to substract to the width. 
  //        It is used to avoid an overflow which would make the page width scrollable.
  //return a visualisation which update itself in function to real time MediaRecorder state.
  const width = window.innerWidth - padding
  return (
        <LiveAudioVisualizer
          mediaRecorder={recorder}
          width={width}
          height={150}
          barWidth={20}
          gap={5}
          barColor={'#f76565'}
          smoothingTimeConstant={0.8}
        />

  )
}


export function BlobWaveform(blob, width, height)
{
  //blob : an audio blob.
  //width, heigth : int.
  //return a static visualisation.


  return (
    <AudioVisualizer
          blob={blob}
          width={width}
          height={75}
          barWidth={1}
          gap={0}
          barColor={'#f76565'}
      />
  )
}
